class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = document.getElementById('facetTrigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.loadAssets());
    }
  }

  initTabs() {
    const tabs = this.querySelectorAll('.drawer__tab');
    const tabContents = this.querySelectorAll('.drawer__tab-content');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;
        
        tabs.forEach(t => t.classList.remove('drawer__tab--active'));
        tabContents.forEach(content => {
          content.classList.remove('drawer__tab-content--active');
          content.style.display = 'none';
        });
        
        tab.classList.add('drawer__tab--active');
        const targetContent = this.querySelector(`[data-tab-content="${targetTab}"]`);
        if (targetContent) {
          targetContent.classList.add('drawer__tab-content--active');
          targetContent.style.display = 'block';
        }
      });
    });
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    } 

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
          this.initTabs();
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    document.body.appendChild(this);
    this.openDrawer();
  }
}
customElements.define('facet-drawer', FacetDrawer);
